import React from 'react';

import { ChartActionItem } from 'pages/reports/components/ChartActionItem/ChartActionItem';
import { SubReport } from 'pages/reports/components/SubReport/SubReport';
import { Report, ReportComponent, ReportSection } from 'apis/ReportApi';
import { Container, Row } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';

import 'pages/reports/components/ChartInfoBox/styles/chart-info-box.scss';

interface Report33Props {
    reportSections: ReportSection[]
}

export const Report33 = ({
    reportSections
}: Report33Props) => {

    const { formatMessage } = useIntl();
    const intl = useIntl();

    const [state, setState] = useSuperState({
        currentActionData: undefined as ReportComponent | undefined,
        currentSubReport: undefined as Report | undefined,
        showActionModal: false
    });

    const { currentActionData, currentSubReport, showActionModal } = state;

    const renderComponents = (component: ReportComponent, loading: boolean, index: number) => {

        if (component.Type === 'ListOfActionItem') {

            const data: any = [];

            component.CustomProperties.Value?.map((result: any) => {

                data.push({
                    Action: `RunSubReport(${result.ResultId},60,87);`,
                    Color: result.ScoreStatus.Color,
                    HoverText: `${formatMessage({ id: 'your_score.0370847c', defaultMessage: 'Your Score:' })} ${result.Score}`,
                    Share: result.ScoreStatus.Share,
                    Title: `${result.TestName} | ${intl.formatDate(new Date(result.FinishDate), { day: 'numeric', month: 'short', year: 'numeric' })}`
                });

            });

            component = {
                ...component,
                Results: {
                    SeriesList: [
                        {
                            Data: data
                        }
                    ]
                },
                Title: formatMessage({ id: 'test_attempts.4c1a6939', defaultMessage: 'Test Attempts' })
            } as ReportComponent;

            return (
                <ChartActionItem
                    component={component}
                    index={index}
                    isSubReport={true}
                    key={index}
                    loading={false}
                    setCurrentActionData={val => setState({ currentActionData: val })}
                    setCurrentSubReport={val => setState({ currentSubReport: val })}
                    setShowActionModal={val => setState({ showActionModal: val })}
                />
            );

        }

        if (component.Type === 'SubReport') {

            return (
                <SubReport
                    component={component}
                    currentSubReport={currentSubReport}
                    index={index}
                    key={index}
                    loading={false}
                    renderComponents={renderComponents}
                />
            );

        }

    };

    return (
        <>
            {
                reportSections.map((section, reportSectionIndex) => (
                    <Container
                        fluid
                        className="mb-3 card card-body"
                        key={reportSectionIndex}
                    >
                        <Row className="m-0">
                            {section.Components.map((component, componentSectionIndex) => renderComponents(component, false, componentSectionIndex))}
                        </Row>
                    </Container>
                ))
            }
        </>
    );

};